import React from 'react'

const TopLead = ({ data, loading }) => {
    return (
        <>
            <div className="col-xl-6">


                <div className="d-lg-flex align-items-center justify-content-between">
                    <h5 className="mt-4 mb-2">
                        <img src={`${process.env.PUBLIC_URL || ""}/assets/images/tag-icon.png`} alt="Tag" /> Top Leads
                    </h5>

                </div>
                <div className="table-responsive" style={{ maxHeight: "340px", marginBottom: "15px" }}>
                    <table
                        id="datatable-checkbox"
                        className="table dashtbl table-striped table-bordered bulk_action mytable dataTable no-footer"
                        style={{ width: "100%" }} 
                        cellPadding={0}
                        cellSpacing={0}
                        role="grid"
                        aria-describedby="datatable-checkbox_info"
                    >
                        <thead>
                            <tr role="row">
                                <th style={{ width: 84 }}>Lead ID</th>
                                <th style={{ width: 170 }}>Client</th>
                                <th style={{}}>Staff</th>
                                <th style={{ width: 100 }}>Date</th>
                                <th style={{ width: 120 }}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        Loading...
                                    </td>
                                </tr>
                            ) : data?.topFiveLead && data.topFiveLead.length > 0 ? (
                                data.topFiveLead.map((lead, index) => (
                                    <tr key={index}>
                                        <td>
                                            <a href="">#{lead.leadId}</a>
                                        </td>
                                        <td className="sorting_1">
                                            <div className="userdet">
                                                <div>
                                                    <strong>
                                                        <i className="fal fa-users" /> {lead.name}
                                                    </strong>
                                                </div>
                                                {lead.email ? (
                                                    <div>
                                                        <i className="fa fa-envelope" /> {lead.email}
                                                    </div>
                                                ) : null}
                                                {(lead.mobile || lead.clientMobile) ? (
                                                    <div>
                                                        <i className="fa fa-mobile" /> {lead.mobile || lead.clientMobile}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </td>
                                        <td>{lead.agentId?.name || 'N/A'}</td>
                                        <td>{lead.createdAt ? new Date(lead.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'N/A'}</td>
                                        <td>
                                            <span className={
                                                lead.leadStatus === 'Paid' ? 'statusactive' :
                                                lead.leadStatus === 'Not Interested' || lead.leadStatus === 'Rejected' ? 'statuscancel' :
                                                'statusprogress'
                                            }>
                                                {lead.leadStatus}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No leads found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="card topselling-plan overflow-hidden mb-3">
                    <div className="card-body px-4 pt-2 pb-0">
                        <div className="d-flex align-items-center justify-content-start">
                            <img src={`${process.env.PUBLIC_URL || ""}/assets/images/bulbicon.png`} className="mr-2" alt="Bulb" />
                            <h1 className="pt-0">
                                <strong>{loading ? "Loading..." : Math.round(data?.conversionRate || 0)}%</strong>
                            </h1>
                        </div>
                        <h6 className="mb-0">Conversion Rate</h6>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TopLead